// extracted by mini-css-extract-plugin
export default {"emptyStub":"CoursesList_emptyStub__Or0LS","wrapper":"CoursesList_wrapper__picnz"};